import React from 'react';
import { setFormField } from "../../../store/reducers/registrationSlice";
import { useFormContext } from 'react-hook-form';
import {useSelector} from "react-redux";
import {translate} from "../../../i18n";

const Step1CompanyInfo = ({ formFields, dispatch, translate, fields }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const language_code = useSelector(state => state.lang);
  return (
    <>
      {fields.map(field => {
  const label = translate('signup', language_code.lang)[field];

  if (field === 'companySector') {
    return (
      <div key={field}>
        <label>{label}</label>
        <select {...register(field, { required: `${label} requis` })}>
          <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
          <option value="public">{translate('company_informations', language_code.lang).company_sector.public}</option>
          <option value="private">{translate('company_informations', language_code.lang).company_sector.private}</option>
        </select>
        {errors[field] && <p>{errors[field].message}</p>}
      </div>
    );
  } else if (field === 'companyStatus') {
    return (
      <div key={field}>
        <label>{label}</label>
        <select {...register(field, { required: `${label} requis` })}>
          <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
          <option value="sa">{translate('company_informations', language_code.lang).company_status.sa}</option>
          <option value="ong">{translate('company_informations', language_code.lang).company_status.ong}</option>
          <option value="sas">{translate('company_informations', language_code.lang).company_status.sas}</option>
          <option value="sarl">{translate('company_informations', language_code.lang).company_status.sarl}</option>
          <option value="scop">{translate('company_informations', language_code.lang).company_status.scop}</option>
          <option value="gie">{translate('company_informations', language_code.lang).company_status.gie}</option>
          <option value="ei">{translate('company_informations', language_code.lang).company_status.ei}</option>
        </select>
        {errors[field] && <p>{errors[field].message}</p>}
      </div>
    );
  } else if (field === 'companyAgroRealm') {
    return (
      <div key={field}>
        <label>{label}</label>
        <select {...register(field, { required: `${label} requis` })}>
          <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
          <option value="vegi_prod">{translate('company_informations', language_code.lang).company_activity_realm.vegi_prod}</option>
          <option value="pastoral_prod">{translate('company_informations', language_code.lang).company_activity_realm.pastoral_prod}</option>
          <option value="vegi_indus_transform">{translate('company_informations', language_code.lang).company_activity_realm.vegi_indus_transform}</option>
          <option value="pasto_indus_transform">{translate('company_informations', language_code.lang).company_activity_realm.pasto_indus_transform}</option>
          <option value="agroecology">{translate('company_informations', language_code.lang).company_activity_realm.agroecology}</option>
          <option value="developpement">{translate('company_informations', language_code.lang).company_activity_realm.developpement}</option>
          <option value="fourniture">{translate('company_informations', language_code.lang).company_activity_realm.fourniture}</option>
          <option value="com_distribution">{translate('company_informations', language_code.lang).company_activity_realm.com_distribution}</option>
          <option value="logistique_transport">{translate('company_informations', language_code.lang).company_activity_realm.logistique_transport}</option>
          <option value="agri_finance_insurance">{translate('company_informations', language_code.lang).company_activity_realm.agri_finance_insurance}</option>
          <option value="training_education">{translate('company_informations', language_code.lang).company_activity_realm.training_education}</option>
        </select>
        {errors[field] && <p>{errors[field].message}</p>}
      </div>
    );
  } else if (field === 'responsabilityInCompany') {
    return (
      <div key={field}>
        <label>{label}</label>
        <select {...register(field, { required: `${label} requis` })}>
          <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
          <option value="director">{translate('roles', language_code.lang).app_user_roles.director}</option>
          <option value="manager">{translate('roles', language_code.lang).app_user_roles.manager}</option>
          <option value="it_technician">{translate('roles', language_code.lang).app_user_roles.it_technician}</option>
          <option value="agri_technician">{translate('roles', language_code.lang).app_user_roles.agri_technician}</option>
          <option value="accounting">{translate('roles', language_code.lang).app_user_roles.accounting}</option>
          <option value="production_promoter">{translate('roles', language_code.lang).app_user_roles.production_promoter}</option>
          <option value="fiels_operator">{translate('roles', language_code.lang).app_user_roles.fiels_operator}</option>
        </select>
        {errors[field] && <p>{errors[field].message}</p>}
      </div>
    );
  }

  // champs texte par défaut
  return (
    <div key={field}>
      <label>{label}</label>
      <input
        type="text"
        {...register(field, { required: `${label} requis` })}
        defaultValue={formFields[field] || ''}
      />
      {errors[field] && <p>{errors[field].message}</p>}
    </div>
  );
})}

    </>
  );
};

export default Step1CompanyInfo;
